import { styled } from '@mui/material/styles'
import { Box, Button, TextField, Select } from '@mui/material'

export const StyledDialog = styled('div')({
  '& .MuiDialog-paper': {
    borderRadius: '24px',
    width: 480,
    maxWidth: 480,
    margin: '24px',
    maxHeight: 'calc(100vh - 48px)',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column'
  }
})

export const StyledPaper = styled(Box)({
  borderRadius: '24px',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  maxHeight: 'calc(100vh - 48px)',
  position: 'relative'
})

export const FormContainer = styled(Box)({
  padding: '0 24px',
  flex: 1,
  overflowY: 'auto',
  maxHeight: 'calc(100vh - 220px)',
  minHeight: 0,
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
})

export const FieldStack = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  paddingBottom: '16px'
})

export const RowStack = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: '16px'
})

export const NumberInputContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
})

export const NumberButton = styled(Button)({
  width: '24px !important',
  height: '24px !important',
  minWidth: '24px !important',
  padding: '0 !important',
  borderRadius: '50%',
  backgroundColor: '#F7F7F7',
  border: '1px solid #EFEFEF',
  color: '#333',
  '&:hover': {
    backgroundColor: '#EEEEEE'
  },
  '&:disabled': {
    backgroundColor: '#F7F7F7',
    color: '#ccc'
  }
})

export const NumberTextField = styled(TextField)<{ hasError?: boolean }>(({ hasError }) => ({
  width: 64,
  background: 'white !important',
  '& .MuiOutlinedInput-root': {
    height: 40,
    borderRadius: '8px',
    backgroundColor: 'white',
    '& fieldset': {
      borderColor: hasError ? '#f44336' : '#EFEFEF'
    },
    '&:hover fieldset': {
      borderColor: hasError ? '#f44336' : '#EFEFEF'
    },
    '&.Mui-focused fieldset': {
      borderColor: hasError ? '#f44336' : '#2570EB'
    }
  },
  '& .MuiOutlinedInput-input': {
    fontSize: '12px'
  }
}))

export const StyledTextField = styled(TextField)<{ hasError?: boolean }>(({ hasError }) => ({
  background: 'white !important',
  '& .MuiOutlinedInput-root': {
    height: 40,
    borderRadius: '8px',
    backgroundColor: 'white',
    '& fieldset': {
      borderColor: hasError ? '#f44336' : '#EFEFEF'
    },
    '&:hover fieldset': {
      borderColor: hasError ? '#f44336' : '#EFEFEF'
    },
    '&.Mui-focused fieldset': {
      borderColor: hasError ? '#f44336' : '#2570EB'
    }
  },
  '& .MuiOutlinedInput-input': {
    fontSize: '12px'
  },
  '& .MuiInputBase-input::placeholder': {
    fontSize: '12px',
    color: '#989898'
  }
}))

export const StyledTextArea = styled(TextField)<{ hasError?: boolean }>(({ hasError }) => ({
  width: '100%',
  background: 'white !important',
  '& .MuiOutlinedInput-root': {
    height: 80,
    borderRadius: '8px',
    backgroundColor: 'white',
    alignItems: 'flex-start',
    '& fieldset': {
      borderColor: hasError ? '#f44336' : '#EFEFEF'
    },
    '&:hover fieldset': {
      borderColor: hasError ? '#f44336' : '#EFEFEF'
    },
    '&.Mui-focused fieldset': {
      borderColor: hasError ? '#f44336' : '#2570EB'
    }
  },
  '& .MuiOutlinedInput-input': {
    fontSize: '12px',
    height: '80px !important',
    maxHeight: '80px',
    overflow: 'auto',
    resize: 'none'
  },
  '& .MuiInputBase-input::placeholder': {
    fontSize: '12px',
    color: '#989898'
  }
}))

export const StyledSelect = styled(Select)({
  height: 40,
  borderRadius: '8px',
  backgroundColor: 'white !important',
  fontSize: '12px',
  '& .MuiOutlinedInput-root': {
    height: 40,
    borderRadius: '8px',
    backgroundColor: 'white !important',
    '& fieldset': {
      borderColor: '#EFEFEF'
    },
    '&:hover fieldset': {
      borderColor: '#EFEFEF'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#2570EB'
    }
  },
  '& .MuiSelect-select': {
    backgroundColor: 'white !important',
    fontSize: '12px'
  },
  '& .MuiSelect-placeholder': {
    fontSize: '12px',
    color: '#989898'
  },
  '& fieldset': {
    borderColor: '#EFEFEF'
  },
  '&:hover fieldset': {
    borderColor: '#EFEFEF'
  },
  '&.Mui-focused fieldset': {
    borderColor: '#2570EB'
  }
})

export const ButtonContainer = styled(Box)({
  position: 'sticky',
  bottom: 0,
  backgroundColor: 'white',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '24px',
  padding: '16px 24px',
  borderTop: 'none',
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    left: 24,
    right: 24,
    top: 0,
    height: 1,
    background: '#EFEFEF',
    zIndex: 1
  }
})

export const CancelButton = styled(Box)({
  padding: '12px 24px',
  height: 40,
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  border: '1px solid #EFEFEF',
  backgroundColor: 'white',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#f5f5f5'
  }
})

export const SubmitButton = styled('button')<{ loading?: boolean }>(({ loading }) => ({
  padding: '12px 24px',
  height: 40,
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  border: 'none',
  backgroundColor: '#2570EB',
  color: 'white',
  cursor: loading ? 'not-allowed' : 'pointer',
  '&:hover': {
    backgroundColor: loading ? '#2570EB' : '#1d5acc'
  }
}))

export const CheckboxContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  height: 24,
  minHeight: 24
})

export const StyledCheckbox = styled(Box)({
  width: 24,
  height: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})